import {CommonPageTextItem} from "./marlenka-page-settings";

export interface DistributionPageTexts {
  jumbotron: CommonPageTextItem;
}


